module.exports = require('./helpers/bundle-url').getBundleURL('dgt5F') + "new_pfp.f412a206.png";